export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

const CLIENT_DISPLAY: Record<string, string> = {
  'cursor-vscode': 'Cursor',
  'claude-code': 'Claude Code',
  'claude-desktop': 'Claude Desktop',
  codex: 'Codex',
  windsurf: 'Windsurf',
  cursor: 'Cursor',
  claude: 'Claude',
  vscode: 'VS Code',
  'claude-ai': 'Claude',
};

export function friendlyClient(name?: string | null): string {
  if (!name) return '—';
  const lower = name.toLowerCase();
  for (const [key, label] of Object.entries(CLIENT_DISPLAY)) {
    if (lower.includes(key)) return label;
  }
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export function fmtTime(iso: string): string {
  const d = new Date(iso);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const t = d.toLocaleTimeString('en-HK', { hour12: false });
  return `${y}-${m}-${day} ${t}`;
}

export function minAgo(ms: number): string {
  const m = Math.floor((Date.now() - ms) / 60000);
  return m < 1 ? 'just now' : m < 60 ? `${m}m ago` : `${Math.floor(m / 60)}h ${m % 60}m ago`;
}

export function maskToken(token: string): string {
  if (token.length < 12) return '••••';
  return `${token.slice(0, 6)}…${token.slice(-4)}`;
}
